import { Box, Container, Heading, List, ListIcon, ListItem, Text, VStack, Code } from '@chakra-ui/react'
import { FiCheck } from 'react-icons/fi'

export const ApiProductionPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading as="h1" size="xl" color="brand.500" mb={3}>
            API: производственный контур
          </Heading>
          <Text color="gray.600">
            Бизнес-сущности планирования: объекты, шаблоны, блоки, бригады и отчёты.
          </Text>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Группы эндпоинтов</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/objects</Code> — объекты строительства.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/object-templates</Code> — шаблоны объектов и заготовки.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/blocks</Code> — рабочие блоки в графике.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/brigs</Code> — бригады и их назначение.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/reports</Code> — экспорт XLSX (месячные отчёты, отчёты по бригадам).</ListItem>
          </List>
        </Box>
      </VStack>
    </Container>
  )
}
